import React from "react";

const DefaultBaseMenu = (props) => {
  const { text, className, onClick } = props;
  return (
    <button onClick={onClick}>
      <div
      className={`flex h-full w-full flex-col items-center justify-center rounded-md p-4 lg:py-28 
      ${
        className !== null
          ? className
          : ""
      }`}
    >
       {props.icon ? props.icon : <span></span>}{" "}
      <h4 className="mb-px mt-1 text-2xl font-bold text-white">{text}</h4>
    </div>
    </button>
  );
};

export default DefaultBaseMenu;
